import { useRepositoryQuery } from '@mews-commander/data-access';

interface UseCorrectionDetailProps {
    correctionBillId: string;
    enabled?: boolean;
}

export const useCorrectionDetail = ({ correctionBillId, enabled = true }: UseCorrectionDetailProps) =>
    useRepositoryQuery(
        'corrections',
        'getAllByIds',
        { correctiveBillIds: [correctionBillId] },
        {
            select: (queryResult) => {
                const {
                    correctedBills = [],
                    correctiveBills = [],
                    billProfiles = [],
                    owners = [],
                    correctiveOrderItems,
                } = queryResult;

                const correctiveBill =
                    correctiveBills?.length === 1
                        ? correctiveBills[0]
                        : correctiveBills?.find((corrective) => corrective.id === correctionBillId);

                const correctiveOwner =
                    owners?.length === 1 ? owners[0] : owners?.find((owner) => owner.id === correctiveBill?.ownerId);

                const correctedBill =
                    correctedBills?.length === 1
                        ? correctedBills[0]
                        : correctedBills?.find((corrected) => corrected.id === correctiveBill?.correctedBillId);

                const creatorProfile = billProfiles?.find((creator) => creator.id === correctiveBill?.creatorProfileId);

                return {
                    correctiveBill,
                    correctedBill,
                    creatorProfile,
                    owner: correctiveOwner,
                    correctiveOrderItems,
                };
            },
            enabled,
        }
    );
